import React, { useState } from 'react';
import { SectionFolder } from '@src/components/SectionFolder';
import { SectionTitle } from '@src/components/SectionTitle';
import { LocalCatalogIcon } from '../../Icons/DropDownIcons/LocalCatalog';
import { SectionProps } from '../types/Settings';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { SECTION_TITLE_SIZE } from '../utils/variables';
import { SectionContent } from '../subcomponents/SectionContent';
import { DropDown } from '@src/components/DropDown';
import { ProductsLocalizationMapping } from 'common';
import { style } from 'typestyle';
import { createChangeSettings } from '../utils/createChangeSettings';
import { Tooltip } from '@mui/material';
import { InfoSvgIcon } from '@src/components/SvgIcons/Info';
import { ADALONG_COLORS } from '@src/styles';

interface LocalCatalogProps extends SectionProps {
  productCountryMappings?: ProductsLocalizationMapping[];
  setCurrentLocalCatalog: (loc: string) => void;
}

const LocalCatalog = ({
  opened,
  onOpen,
  editedWidget,
  setEditedWidget,
  productCountryMappings,
  setCurrentLocalCatalog,
}: LocalCatalogProps) => {
  const [displayDropdown, setDisplayDropdown] = useState<boolean>(false);
  const changeSettings = createChangeSettings(editedWidget, setEditedWidget);

  function selectLocalCatalog(e: React.MouseEvent<HTMLDivElement, MouseEvent>, loc: string) {
    e.stopPropagation();
    changeSettings({
      localization: loc,
    });
    setDisplayDropdown(false);
    setCurrentLocalCatalog(loc);
  }

  return (
    <SectionFolder
      title={
        <SectionTitle size={SECTION_TITLE_SIZE}>
          <LocalCatalogIcon />
          {lang.title}
        </SectionTitle>
      }
      opened={opened}
      afterTitle={
        <Tooltip title={lang.tooltips.localCatalog} placement="top">
          <span className={infoLocalCatalogClass}>
            <InfoSvgIcon />
          </span>
        </Tooltip>
      }
      onOpen={onOpen}
    >
      <SectionContent>
        {productCountryMappings?.length ? (
          <DropDown
            title={editedWidget.settings.localization || 'Select a local catalog'}
            display={displayDropdown}
            onDisplay={setDisplayDropdown}
          >
            {productCountryMappings.map((mapping, i) =>
              mapping.name !== editedWidget.settings.localization ? (
                <div
                  className={selectionClass}
                  key={i}
                  data-selected={mapping.name === editedWidget.settings.localization}
                  onClick={(e) => selectLocalCatalog(e, mapping.name)}
                >
                  {mapping.name}
                </div>
              ) : null,
            )}
          </DropDown>
        ) : (
          lang.fields.noLocalCatalogAvailable
        )}
      </SectionContent>
    </SectionFolder>
  );
};

const lang = LocalizedStrings({
  en: {
    title: 'Local Catalog',
    tooltips: {
      localCatalog: 'Choose a specific country or region catalog to display localized product recommendations',
    },
    fields: { noLocalCatalogAvailable: 'No local catalog available' },
  },
});

const infoLocalCatalogClass = style({
  marginLeft: 10,
  color: ADALONG_COLORS.LIGHT_GRAY,
});

const selectionClass = style({
  $nest: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default LocalCatalog;
